import React from 'react';
import clsx from 'clsx';

import './index.scss';

import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import {
  getChoiceLabel,
  getChoiceValues,
}from 'utils';

const PcTypeItem = ({ 
  title,
  text,
  isAllCheck,
  allCheckOnChange,
  typeState,
  stateOnChange,
}) =>{
  const listValues = getChoiceValues(title);
  return(
    <div className="PcTypeItem">
      <div className="PTI-title">
        {text}
      </div>
      <div className="PTI-allCheck">
        <NormalCheckBoxInput
          checked={isAllCheck}
          key={title}
          id={title}
          label='すべて'
          onChange={allCheckOnChange}
          value={isAllCheck}
          color="0"
        />
      </div>
      <div className={clsx('PTI-input', 
        { physicalCare: text === '身体介護' },
        { lifeSupport: text === '生活援助' },
      )}
      >
        {listValues.map((value) => {
          const choicelabel = getChoiceLabel(title, value);
          return (
            <NormalCheckBoxInput
              checked={typeState.includes(value)}
              key={choicelabel}
              id={choicelabel}
              label={choicelabel}
              onChange={stateOnChange}
              value={value}
              color="0"
            />
          );
        })}
      </div>
      <div className="PTI-horizon" />
    </div>
  );
};
export default PcTypeItem;